import { render, staticRenderFns } from "./CreateFileUpload.vue?vue&type=template&id=2801ca3c"
import script from "./CreateFileUpload.vue?vue&type=script&lang=js"
export * from "./CreateFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports